import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundComment.Save.IRequest;
type Response = Api.Sales.ContractRefundComment.Save.IResponse;
type Headers = Api.Sales.ContractRefundComment.Save.IHeaders;
const url = '/api/Sales/ContractRefundComment';
export default async function contractRefundCommentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
